import { FilterFieldOperator } from '@/components/table/_filterFieldOperators/FilterFieldOperator.ts';
import { ValueInput } from '@/components/form/ValueInput.tsx';
import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';

export const TourPriceArrayFilterInput = ({
  form,
  index,
}: FilterInputProps) => {
  const operator = form.watch(`filters.${index}.operator`);

  const isBetweenOperator = operator === FilterFieldOperator.BETWEEN;

  return (
    <div className="flex gap-2">
      <ValueInput
        size="toolbar"
        register={form.register(`filters.${index}.value`)}
        placeholder={isBetweenOperator ? 'Od' : 'Cena'}
      />
      {isBetweenOperator && (
        <ValueInput
          size="toolbar"
          register={form.register(`filters.${index}.secondValue`)}
          placeholder={'Do'}
        />
      )}
    </div>
  );
};
